export default {
    workOrder_contact_edit_title: "Edit Contact",
    workOrder_contact_create_title: "Create New Contact",
    workOrder_contact_contact_saved: "Contact Saved",
    workOrder_contact_no_changes_to_save: "No changes to save",
    workOrder_contact_contactNameIsAlreadyInUse: "The name is already in use",
    workOrder_ccontact_contactPhoneIsAlreadyInUse: "The phone is already in use",
    workOrder_contact_contactEmailIsAlreadyInUse: "The email is already in use",
    workOrder_contact_name: "Name",
    workOrder_contact_phone: "Phone",
    workOrder_contact_email: "Email",
    workOrder_contact_notifyByPhone: "Notify By Phone",
    workOrder_contact_notifyByEmail: "Notify By Email",
    workOrder_contact_codeCountry: "Code Country",
};